import CityCard from './CityCard/CityCard'


const CityCards = ({ cities, sortOrder, pageSize, loadIndex }) => {
  let sortedGrid = [];
  if (cities) {
    sortedGrid = cities.slice(0, loadIndex * pageSize)?.sort((a, b) => {
      if (sortOrder === "mostRecent") {
        return new Date(b.createdAt) - new Date(a.createdAt);
      } else if (sortOrder === "mostDesigns") {
        return b.designsCount - a.designsCount;
      } else if (sortOrder === "leastDesigns") {
        return a.designsCount - b.designsCount;
      }
    });
  }

  return (
    <div className="grid-components-wrapper">
      {sortedGrid?.map((gridElement, index) => (
        <div className="card_wrapper_component" key={index}>
            <CityCard
              key={gridElement?.id}
              id={gridElement?.id}
              name={gridElement?.name}
              country={gridElement?.country}
              location={[gridElement?.langth, gridElement?.latitued]}
              pinCount={gridElement?.pinCount}
              designsCount={gridElement?.designsCount}
              image={gridElement?.image}
              isAdmin={false}
            /> 
        </div>
        ))}
    </div>
  );
};

export default CityCards;
{/* <GridCard
key={gridElement?.id}
id={gridElement?.id}
name={sortedGrid?.name}
cityName={sortedGrid?.name}
country={sortedGrid?.country}
location={[gridElement?.langth, gridElement?.latitued]}
pinCount={gridElement?.pinCount}
designsCount={gridElement?.designsCount}
image={gridElement?.image}
typeGrid={typeGrid}
isAdmin={false}
/> */}